import { usePersistence } from '@segments/Storage'
import * as React from 'react'

import {
  ContactInputGroup as SharedContactInputGroup,
  TPersistedForm,
} from '~shared/segments/FormScreen'

type TProps = NoChildren

/**
 * Wrapper for grouping together basic customer information inputs.
 */
export const ContactInputGroup: React.FC<TProps> = () => {
  const [, persistForm, resetFormPersistence] = usePersistence<TPersistedForm>({
    key: `orderForm`,
  })

  return (
    <SharedContactInputGroup
      persistForm={persistForm}
      resetFormPersistence={resetFormPersistence}
    />
  )
}
